import React, { memo } from 'react'
import classNames from 'classnames'
import PatternFormat, { IPatternFormatProps } from 'transfix-ui/components/PatternFormat'

export interface IDateProps {
  placeholder?: string
  value: string
  disabled?: boolean
  mask?: string
  id: string
  name?: string
  label?: string
  required?: string
  'data-test'?: string
  invalid?: boolean
  validationMessage?: string
  className?: string
  ariaLabel?: string
  onChange: (formattedValue: string, name?: string, id?: string) => void
}

const isValidDate = (value: string): boolean => {
  return !value || (!!value && value.indexOf('-') < 0)
}

export const DateInput = memo(
  ({
    ariaLabel,
    className: classNameProp,
    'data-test': dataTest,
    disabled,
    id,
    invalid,
    label,
    name,
    onChange: onChangeProp,
    placeholder,
    required,
    validationMessage,
    value,
  }: IDateProps) => {
    const onChange: IPatternFormatProps['onValueChange'] = ({ formattedValue }) => {
      if (isValidDate(formattedValue)) {
        onChangeProp(formattedValue, name, id)
      }
    }

    const className = classNames('text-input', classNameProp, {
      invalid,
      disabled,
    })

    return (
      <div className={className}>
        {label && (
          <label htmlFor={id} className={`label ${required && 'required'}`}>
            {label}
          </label>
        )}
        <div className='text-input-container'>
          <PatternFormat
            type='text'
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            format='##/##/####'
            mask='-'
            id={id}
            name={name}
            data-test={dataTest}
            displayType='input'
            onValueChange={onChange}
            aria-label={ariaLabel}
          />
        </div>
        {invalid && (
          <span data-test={`${dataTest}-message`} className='validation-message'>
            {validationMessage}
          </span>
        )}
      </div>
    )
  }
)

export default DateInput
